import React from "react";
import Balancer from "react-wrap-balancer";
import { Box } from "@chakra-ui/react";
import { Section } from "components/section";
import { BookDemoButton } from "components/event-tracking";
import { FadeIn } from "ui/animations";
import { TextTitle } from "ui/text";
import { AuraPlate } from "ui/plates";
import { desktopOnlyDisplay, mobileOnlyDisplay } from "utils";
import { AidDemoVideo } from "./aid-demo-video";

type HeroProps = {
  eyebrow: string;
  title: string;
  description: string;
};

export function AiDecisioningHero({ eyebrow, title, description }: HeroProps) {
  return (
    <Section
      bg="new.violet.150"
      themeBgColor="new.violet.150"
      py="0"
      pt={{ base: "big", md: "biggest" }}
      pb={{ base: "bigger", md: "0" }}
      pos="relative"
    >
      <FadeIn>
        <Box pos="relative">
          <TextTitle
            size="xl"
            chip={{ text: eyebrow }}
            title={<Balancer>{title}</Balancer>}
            titleAs="h1"
            description={description}
            descriptionAs="h2"
            maxW="900px"
            actions={<BookDemoButton />}
            align="center"
          />
          <AidDemoVideo display={mobileOnlyDisplay()} borderColor="transparent" borderRadius="small" />
          <AuraPlate
            condensed
            display={desktopOnlyDisplay()}
            variant="violet"
            px="0"
            platePx={{ base: "0", md: "bigger" }}
            platePy={{ base: "0", md: "bigger" }}
          >
            <AidDemoVideo borderColor="transparent" borderRadius="bigger" mt="0" />
          </AuraPlate>
        </Box>
      </FadeIn>
    </Section>
  );
}
